<script>
import { API_ROOT_URL } from '@/libs/serviceUrls'
import Vue from 'vue'
import axios from "@/libs/axios";

export default Vue.extend({
  name: "List",
  data: () => ({
    list: []
  }),
    computed: {
        apiRootUrl: () => API_ROOT_URL,
    },
  methods: {
    getList() {
      this.list = []
      axios.get('/excel/trendyol/product')
          .then(res => {
            this.list = res.data.files
          })
          .finally(() => {
            this.$swal({
              title: "Başarılı",
              text: "Excel Listesi Çekildi",
              icon: "success",
              timer: 1000
            })
          })
    },
    deleteFile(name) {
      axios.delete('/excel/trendyol/product/' + name)
          .then(res => {
            if (res.data.status === 'success') {
              this.list = this.list.filter(item => item.name !== name)
              this.$swal({
                title: "Başarılı",
                text: "Excel Listesi Çekildi",
                icon: "success",
                timer: 1000
              })
            }
          })
          .catch(() => {
            this.$swal({
              title: "Başarısız",
              text: "Excel Listesi Silinemedi",
              icon: "error",
              timer: 1000
            })
          })
    },
    formatDate(timestamp) {
      // Laravel lastModified -> Unix timestamp (saniye)
      const date = new Date(timestamp * 1000)
      return date.toLocaleString("tr-TR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      })
    }
  }
})
</script>

<template>
  <section id="search-section">
    <b-row>
      <b-col md="12">
        <b-card>
          <b-card-header class="d-flex justify-content-end">
            <b-button variant="primary" @click="getList">Listele</b-button>
          </b-card-header>
          <b-card-body>
            <b-row v-for="item in list" :key="item.last_modified" class="mt-1 border">
              <b-col cols="4"> {{ formatDate(item.last_modified) }}</b-col>
              <b-col cols="4">{{ item.name }}</b-col>
              <b-col cols="4">
                <b-button-group size="sm">
                  <!-- İndir butonu -->
                  <b-button
                      variant="primary"
                      :href="apiRootUrl + 'storage/exports/' + item.name"
                      download
                  >
                    <b-icon icon="download"></b-icon>
                  </b-button>

                  <!-- Sil butonu -->
                  <b-button
                      variant="danger"
                      @click="deleteFile(item.name)"
                  >
                    <b-icon icon="trash"></b-icon>
                  </b-button>
                </b-button-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </section>
</template>

<style scoped>

</style>
